export class FormBuilderNotificationEmail {
  public constructor() {
    this.Email = '';
  }
  public Email: string;
}
